import React, { Fragment } from "react";
import "./injuryClaims.scss";
import { InjuryClaimData } from "../../utils/InjuryClaimData";
import Slider from "react-slick";
const InjuryClaims = () => {


  
  const settings = {
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 991, // For screens less than or equal to 991px
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For screens less than or equal to 768px
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575, // For screens less than or equal to 575px
        settings: {
          slidesToShow: 1, // Show 2 slides
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Fragment>
      <div className="injuryClaims">
        <div className="container1286">
          <h2 className="injuryClaims-title">
            Examples <span>of Disrepair</span>
          </h2>

          <div className="injuryClaims-types">
            <Slider  {...settings}>
              {InjuryClaimData?.map((data) => (
                <div className="type" key={data?.id}>
                  <div className="tp">
                    <img
                      className="img"
                      src={data?.img}
                      alt={data?.title}
                    />
                  </div>
                </div>
              ))}
            </Slider>
           
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default InjuryClaims;
